import { PARTNER_TYPES } from '../../partner-types';
import { MenuItem } from '../types';
import { Roles } from '../../roles';
import { PARTNER_FEATURE_FLAGS } from '../../partner-features';

export const accountManagement: MenuItem[] = [
  {
    headTitle1: 'Account Management',
    type: 'headtitle',
  },
  {
    title: 'Payment Method',
    icon: 'stroke-order',
    iconf: 'fill-order',
    path: '/account-management/payment-method',
    activePathPrefixes: ['/account-management/payment-method'],
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    excludedPartners: ['ryd'],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
  },
  {
    title: 'Invoices',
    icon: 'file-text',
    iconf: 'file-text',
    path: '/account-management/invoices',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    excludedPartners: ['ryd'],
    requiredRoles: [Roles.fleet_Admin, Roles.fleet_Manager],
  },
  {
    path: '/documents',
    activePathPrefixes: ['/documents'],
    title: 'Documents',
    icon: 'stroke-file',
    iconf: 'fill-file',
    type: 'link',
    active: false,
    requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DOCUMENTS,
    keywords: ['documents', 'files', 'shared files', 'downloads'],
  },
  {
    path: '/account-management/list-prices',
    title: 'List Prices',
    icon: 'stroke-table',
    iconf: 'fill-table',
    type: 'link',
    active: false,
    requiresListPrice: true,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER, PARTNER_TYPES.API_PARTNER],
  },
  {
    path: '/account-management/account-settings',
    title: 'Account Settings',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
  },
  {
    path: '/account-management/account-settings-poland-invoice',
    title: 'Account Settings',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'link',
    active: 'false',
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    path: '/account-management/account-settings-individual',
    title: 'Account Settings',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'link',
    active: 'false',
    requiredUserGroup: ['oilpay', 'allguth'],
  },
  {
    title: 'Exports',
    icon: 'stroke-file',
    iconf: 'fill-file',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL, PARTNER_TYPES.API_PARTNER],
    requiresFleetApis: true,
    path: '/account-management/exports',
  },
  // Sub-fleet variant: same centre, gated by the sub-fleet flag instead of
  // fleet APIs (their transaction CSV exports land here).
  {
    title: 'Exports',
    icon: 'stroke-file',
    iconf: 'fill-file',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.FLEET_PARTNER],
    requiresSubFleet: true,
    path: '/account-management/exports',
  },
];
